"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = exports.minusOne = void 0;

var _breakpoints = _interopRequireDefault(require("./breakpoints"));

var px = 'px';

var minusOne = function minusOne(breakpoint) {
  var reduceOne = (breakpoint.slice(0, -2) - 1).toString().concat(px);
  return reduceOne;
};

exports.minusOne = minusOne;
var mediaQueries = {
  untilSmall: "@media screen and (max-width: ".concat(minusOne(_breakpoints.default[0]), ")"),
  small: "@media screen and (min-width: ".concat(_breakpoints.default[0], ")"),
  untilMedium: "@media screen and (max-width: ".concat(minusOne(_breakpoints.default[1]), ")"),
  medium: "@media screen and (min-width: ".concat(_breakpoints.default[1], ")"),
  untilLarge: "@media screen and (max-width: ".concat(minusOne(_breakpoints.default[2]), ")"),
  large: "@media screen and (min-width: ".concat(_breakpoints.default[2], ")"),
  untilXlarge: "@media screen and (max-width: ".concat(minusOne(_breakpoints.default[3]), ")"),
  xlarge: "@media screen and (min-width: ".concat(_breakpoints.default[3], ")")
};
var _default = mediaQueries;
exports.default = _default;